module.exports = __webpack_public_path__ + "img/40_38_051_680.0514481b.jpg";